import { render, staticRenderFns } from "./TournamentInstance.vue?vue&type=template&id=770ac53d&"
import script from "./TournamentInstance.vue?vue&type=script&lang=ts&"
export * from "./TournamentInstance.vue?vue&type=script&lang=ts&"
import style0 from "./TournamentInstance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports